import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {TimeOffRequestsComponent} from "../time-off-requests.component";
import {PersonalTimesGridViewDto} from "@services";
import {DxButtonComponent, DxDataGridComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent, DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoScrollingComponent,
    DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {DatePipe, NgClass} from "@angular/common";
import {UserAvatarEmailComponent} from "../../../../components/utils/user-avatar-email/user-avatar-email.component";
import {PersonalTimePopupComponent} from "./personal-time-popup/personal-time-popup.component";
import {ToDatePipe} from "../../../../pipes/to-date.pipe";
import {TimeOffFilterPanelComponent} from "../time-off-filter-panel/time-off-filter-panel.component";

@Component({
  selector: 'app-personal-times',
    imports: [
        DxDataGridComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoScrollingComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxiButtonComponent,
        CapitalCasePipe,
        NgClass,
        UserAvatarEmailComponent,
        PersonalTimePopupComponent,
        DxButtonComponent,
        DatePipe,
        DxTemplateDirective,
        ToDatePipe,
        TimeOffFilterPanelComponent
    ],
  templateUrl: './personal-times.component.html'
})
export class PersonalTimesComponent extends TimeOffRequestsComponent<PersonalTimesGridViewDto> implements OnChanges {
    constructor() {
        super();
        this.init(PersonalTimesGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['employeeId']) {
            this.dataSource = this.dataSources.personalTimes(this.employeeId);
        }
    }

    dataSource = this.dataSources.personalTimes(null);
    filterModel: PersonalTimesGridViewDto = new PersonalTimesGridViewDto();
    gridFieldName = (name: keyof PersonalTimesGridViewDto): string => name;
    filterModelName = (name: keyof PersonalTimesGridViewDto): string => name;
    protected override exportName: string = "Personal Times";
    protected tabName = 'personal-time';

    getCellData(cellInfo: { data: PersonalTimesGridViewDto }) {
        return cellInfo.data;
    }
}
